import _ from 'lodash';
import { authenticatedInstance } from 'api';
import { triggerToast } from 'redux/actions/ui';

export const LOAD_BALANCE = {
  STARTED: 'LOAD_BALANCE_STARTED',
  SUCCESS: 'LOAD_BALANCE_SUCCESS',
  FAIL: 'LOAD_BALANCE_FAIL',
};

export const LOAD_PAIRS = {
  STARTED: 'LOAD_PAIRS_STARTED',
  SUCCESS: 'LOAD_PAIRS_SUCCESS',
  FAIL: 'LOAD_PAIRS_FAIL',
};

export const CANCEL_ORDER = {
  STARTED: 'CANCEL_ORDER_STARTED',
  SUCCESS: 'CANCEL_ORDER_SUCCESS',
  FAIL: 'CANCEL_ORDER_FAIL',
};

export const LOAD_NDWALLET_ORDER_HISTORY = 'LOAD_NDWALLET_ORDER_HISTORY';

// Format the data to a standard data format, this allows us to update in one place if
// data formats ever change on the backend.
const formatMarketData = (singleMarketData) => {
  const { base, quote, maker_fee, maker_fee_pro, taker_fee, taker_fee_pro } = singleMarketData;

  return {
    baseCurrency: base,
    quoteCurrency: quote,
    tradingPair: {
      baseCurrency: base,
      quoteCurrency: quote,
    },
    tradingFees: {
      makerFee: maker_fee,
      takerFee: taker_fee,
    },
    tradingFeesPro: {
      makerFee: maker_fee_pro,
      takerFee: taker_fee_pro,
    },
  };
};

export const getNDWalletBalance = () => {
  return async (dispatch) => {
    dispatch({
      type: LOAD_BALANCE.STARTED,
    });

    try {
      const { data } = await authenticatedInstance({
        url: '/okx/balance',
        method: 'GET',
      });

      if (_.isEqual(data.status, 'Success')) {
        dispatch({
          type: LOAD_BALANCE.SUCCESS,
          payload: data.data,
        });
      } else {
        if (_.isEqual(data.message, 'OKX_Failure')) {
          dispatch(triggerToast(data.data, 'error'));
        }
        dispatch({ type: LOAD_BALANCE.FAIL });
        // dispatch(triggerToast('somethingWentWrong'));
      }
    } catch (e) {
      console.log(e.response);
      dispatch({ type: LOAD_BALANCE.FAIL });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const getNDWalletPairs = () => {
  return async (dispatch) => {
    dispatch({
      type: LOAD_PAIRS.STARTED,
    });

    try {
      const { data } = await authenticatedInstance({
        url: '/okx/pairs',
        method: 'GET',
      });

      if (_.isEqual(data.status, 'Success')) {
        const formattedMarketData = data.data.map((singleMarketData) => formatMarketData(singleMarketData));
        let tradingPairs = [];
        formattedMarketData.forEach((singleMarketData) => {
          const { tradingPair } = singleMarketData;
          tradingPairs.push(tradingPair);
        });
        dispatch({
          type: LOAD_PAIRS.SUCCESS,
          payload: tradingPairs,
        });
      } else {
        if (_.isEqual(data.message, 'OKX_Failure')) {
          dispatch(triggerToast(data.data, 'error'));
        }
        dispatch({ type: LOAD_PAIRS.FAIL });
      }
    } catch (e) {
      dispatch({ type: LOAD_PAIRS.FAIL });
    }
  };
};

export const cancelOrderNDWallet = (order) => {
  return async (dispatch, getState) => {
    dispatch({
      type: CANCEL_ORDER.STARTED,
    });

    try {
      const { data } = await authenticatedInstance({
        url: '/api/CancelOrder',
        method: 'POST',
        data: {
          side: order.side.toUpperCase(),
          pair: `${order.trade}_${order.market}`,
          orderId: order.order_id,
        },
      });

      if (data.status === 'Success') {
        dispatch({
          type: CANCEL_ORDER.SUCCESS,
        });
        dispatch(triggerToast('orderCancelled', 'success'));
        dispatch(updateNDOrderHistory(true));
      } else {
        dispatch({
          type: CANCEL_ORDER.FAIL,
        });
        if (_.isEqual(data.message, 'OKX_Failure')) {
          dispatch(triggerToast(data.data, 'error'));
        } else {
          dispatch(triggerToast(data.message, 'error'));
        }
      }
    } catch (e) {
      // dispatch(triggerToast('somethingWentWrong'));
      dispatch({
        type: CANCEL_ORDER.FAIL,
      });
    }
  };
};

export const updateNDOrderHistory = (data) => {
  return (dispatch) => {
    dispatch({
      type: LOAD_NDWALLET_ORDER_HISTORY,
      payload: data,
    });
  };
};
